import { MsDisabled as F, MsWarningCircle as V } from "@sunrise/icons";
import { defineComponent as b, toRef as o, ref as h } from "vue";
import { addFormFieldErrorHandling as v, addFormFieldBehavior as B } from "./index5.js";
const w = b({
  name: "CsTextarea",
  components: {
    MsWarningCircle: V,
    MsDisabled: F
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    autoFocus: Boolean,
    errorMsg: String,
    isInactive: Boolean,
    label: String,
    limit: Number,
    regex: String,
    cols: { default: 10, type: Number },
    rows: { default: 10, type: Number }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { emit: u }) {
    const l = v(o(e, "errorMsg")), { hasFocus: n, input: i, showReset: m, onInput: s, onBlur: d, onFocus: c, reset: f } = B({
      initialValue: o(() => e.modelValue),
      autoFocus: o(() => e.autoFocus),
      validation: {
        pattern: e.regex
      }
    }), g = h(!1);
    function p(r) {
      const t = r.currentTarget;
      if (e.limit && t.value.length > e.limit) {
        const a = t.value.substring(0, e.limit);
        t.value = a, u("update:modelValue", a);
        return;
      }
      s(r);
    }
    return {
      hasError: l,
      hasFocus: n,
      input: i,
      showReset: m,
      onInputLimited: p,
      onFocus: c,
      onBlur: d,
      showBlink: g,
      reset: f
    };
  }
});
export {
  w as default
};
